import { render } from "./PagesHero.vue?vue&type=template&id=1658a344&scoped=true"
import script from "./PagesHero.vue?vue&type=script&lang=js"
export * from "./PagesHero.vue?vue&type=script&lang=js"

import "./PagesHero.vue?vue&type=style&index=0&id=1658a344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1658a344"]])

export default __exports__